import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Wallet,
  Repeat,
  Layers,
  Users,
  PlayCircle,
  FileCheck,
  ReceiptText,
  ArrowUpRight,
} from "lucide-react";

const tabs = [
  {
    label: "Payroll Reports",
    path: "/admin/payroll-Settings",
    color: "#6366F1",
    icon: ReceiptText,
    desc: "Insights & Reports",
  },
  // {
  //   label: "Pay Cycles",
  //   path: "/admin/pay-cycle-config",
  //   color: "#10B981",
  //   icon: Repeat,
  //   desc: "Salary Periods",
  // },
  {
    label: "Run Payroll",
    path: "/admin/salary-structure-builder",
    color: "#A855F7",
    icon: Layers,
    desc: "Compensation Setup",
  },
  {
    label: "Benefits Administration",
    path: "/admin/user-management",
    color: "#EC4899",
    icon: Users,
    desc: "Allowances & Benefits",
  },
  // {
  //   label: "Run Payroll",
  //   path: "/admin/payroll-run-rollback",
  //   color: "#F59E0B",
  //   icon: PlayCircle,
  //   desc: "Execute Payroll",
  // },
  // {
  //   label: "Full & Final Settlement",
  //   path: "/admin/full-final-settlement",
  //   color: "#06B6D4",
  //   icon: FileCheck,
  //   desc: "Exit Processing",
  // },
  // {
  //   label: "Tax & Form-16",
  //   path: "/admin/tax-form16-setup",
  //   color: "#475569",
  //   icon: Wallet,
  //   desc: "Tax Compliance",
  // },
];

export default function PayrollDashboard() {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <div className="p-8 bg-[#fafafa] min-h-screen font-roboto">
      {/* HEADER */}
      <div className="max-w-6xl mx-auto mb-8">
        <h1 className="text-2xl font-black font-poppins text-slate-900 tracking-tight">
          Payroll <span className="text-indigo-600">& Finance</span>
        </h1>
        <div className="h-1 w-12 bg-indigo-600 mt-1 rounded-full" />
      </div>

      {/* GRID */}
      <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
        {tabs.map((tab) => {
          const isActive = location.pathname === tab.path;
          const Icon = tab.icon;

          return (
            <div
              key={tab.path}
              onClick={() => navigate(tab.path)}
              className={`
                cursor-pointer rounded-2xl p-4 h-40
                flex flex-col justify-between border
                transition-all duration-200 ease-out
                ${isActive
                  ? "border-indigo-500 scale-[1.03]"
                  : "border-slate-200 hover:-translate-y-0.5"}
              `}
              style={{
                backgroundColor: isActive ? tab.color : "#ffffff",
                boxShadow: isActive
                  ? `0 20px 40px -15px ${tab.color}AA`
                  : "0 4px 12px rgba(0,0,0,0.06)",
              }}
            >
              {/* TOP */}
              <div className="flex justify-between items-start">
                <div
                  className="w-10 h-10 rounded-xl flex items-center justify-center"
                  style={{
                    backgroundColor: isActive
                      ? "rgba(255,255,255,0.2)"
                      : `${tab.color}15`,
                    color: isActive ? "#ffffff" : tab.color,
                  }}
                >
                  <Icon size={20} strokeWidth={2.5} />
                </div>

                <ArrowUpRight
                  size={16}
                  className={isActive ? "text-white" : "text-slate-300"}
                />
              </div>

              {/* TEXT */}
              <div>
                <h3
                  className={`text-sm font-black font-poppins tracking-tight mb-0.5 ${
                    isActive ? "text-white" : "text-slate-800"
                  }`}
                >
                  {tab.label}
                </h3>
                <p
                  className={`text-[11px] font-bold uppercase tracking-tighter ${
                    isActive ? "text-white/80" : "text-slate-400"
                  }`}
                >
                  {tab.desc}
                </p>
              </div>

              {/* ACTIVE INDICATOR */}
              {isActive && (
                <div className="absolute top-2 right-2 w-2 h-2 bg-white rounded-full animate-pulse" />
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
